import { useTranslation } from 'react-i18next';
import { useLandingImages } from '@/hooks/useLandingImages';

export default function AboutSection() {
  const { t } = useTranslation();
  const { aboutImage } = useLandingImages();

  return (
    <section id="about" className="bg-[#0A0A0A] py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image Column */}
          <div className="w-full lg:w-[45%] relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={aboutImage}
                alt="Bucara Burger founders - Colombian entrepreneurs in Boise Idaho"
                className="w-full h-[400px] md:h-[550px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            {/* Stat chips */}
            <div className="absolute -bottom-5 left-4 right-4 flex gap-3">
              <div className="flex-1 bg-[#F57F25] rounded-xl p-4 text-center">
                <div className="text-black font-black text-xl">100%</div>
                <div className="text-black/80 text-xs font-semibold">{t('about_stat_1')}</div>
              </div>
              <div className="flex-1 bg-[#111] border border-[#F57F25]/30 rounded-xl p-4 text-center">
                <div className="text-[#F57F25] font-black text-xl">Boise&apos;s</div>
                <div className="text-white/70 text-xs font-semibold">{t('about_stat_2')}</div>
              </div>
            </div>
          </div>

          {/* Text Column */}
          <div className="w-full lg:w-[55%] pt-8 lg:pt-0">
            <div className="inline-flex items-center gap-2 text-[#F57F25] text-xs font-bold tracking-widest uppercase mb-4">
              <div className="w-8 h-px bg-[#F57F25]"></div>
              {t('about_eyebrow')}
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6 uppercase">
              {t('about_headline_1')}<br />
              <span className="text-[#F57F25]">Bucaramanga</span><br />
              {t('about_headline_3')}
            </h2>

            <div className="space-y-4 text-white/65 text-base leading-relaxed">
              <p>{t('about_p1')}</p>
              <p>{t('about_p2')}</p>
              <p>{t('about_p3')}</p>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10 flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F57F25]/10 rounded-full">
                  <i className="ri-heart-line text-[#F57F25] text-lg"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm">{t('about_feat_1_title')}</div>
                  <div className="text-white/50 text-xs">{t('about_feat_1_sub')}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F57F25]/10 rounded-full">
                  <i className="ri-leaf-line text-[#F57F25] text-lg"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm">{t('about_feat_2_title')}</div>
                  <div className="text-white/50 text-xs">{t('about_feat_2_sub')}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F57F25]/10 rounded-full">
                  <i className="ri-map-pin-line text-[#F57F25] text-lg"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm">{t('about_feat_3_title')}</div>
                  <div className="text-white/50 text-xs">{t('about_feat_3_sub')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
